<template>
  <DModal :show-close="false" :is-bg-overlay="true">
    <div class="modal-merges" slot="insertComponent">
      <div class="do-modal__header">
        <h2 v-if="isMergeCalendar">{{ $t('vue2.editCalendarMenu.merge_with_calendar') }}</h2>
        <h2 v-else>{{ $t('vue2.editCalendarMenu.merge_with_merge_calendars') }}</h2>
        <div class="icon__bg-circle" @click="$emit('close')">
          <span class="icon-cross2"></span>
        </div>
      </div>
      <div class="do-modal__body">
        <Loader bg-color="#f6f9fc" :isSmall="true" v-if="isLoadingMerges"></Loader>
        <template v-else>
          <div v-if="isMergeCalendar">
            <label v-if="calendarsMerged.length > 0" class="d-label d-label__divider d-label__divider--top">{{ $t('vue2.editCalendarMenu.is_merged') }}</label>
            <ul>
              <li
                v-for="calendar in calendarsMerged"
                :key="calendar.id"
                class="modal-merges__item"
                @click.stop="unMergeCalendarFromMergeCalendar(calendar)">
                <label class="d-label">{{ calendar.name }}
                  <span class="do-pill marg-05-rem">{{ calendar.year }}</span></label>
                <div class="do-spinner do-spinner--custom-marg" v-if="theLoaderId === calendar.id"></div>
                <div class="do-switch do-switch--active" v-else></div>
              </li>
            </ul>
            <label class="d-label d-label__divider">{{ $t('vue2.editCalendarMenu.can_be_merged_into') }}</label>
            <ul>
              <li
                v-for="calendar in possibleToMerge"
                :key="calendar.id"
                class="modal-merges__item"
                @click.stop="mergeCalendarFromMergeCalendar(calendar)">
                <label class="d-label">{{ calendar.name }}
                  <span class="do-pill marg-05-rem">{{ calendar.year }}</span></label>
                <div class="do-spinner do-spinner--custom-marg" v-if="theLoaderId === calendar.id"></div>
                <div class="do-switch" v-else></div>
              </li>
            </ul>
          </div>
          <ul v-if="!isMergeCalendar">
            <li
              v-for="calendar in allMergeCalendars"
              :key="calendar.id"
              class="modal-merges__item"
              @click.stop="toggleMergeCalendar(calendar)">
              <label class="d-label">{{ calendar.name }}<span class="do-pill do-pill--yellow marg-05-rem"
                                                              v-if="calendar.archived">Archived</span></label>
              <div class="do-spinner do-spinner--custom-marg" v-if="theLoaderId === calendar.id"></div>
              <div class="do-switch" v-else :class="{'do-switch--active': calendar.vIsMerged}"></div>
            </li>
          </ul>
        </template>
      </div>
      <div class="do-modal__footer">
        <button class="do-bttn" @click="$emit('close')">{{ $t('vue2.common.done') }}</button>
      </div>
    </div>
  </DModal>
</template>

<script>
import docendo from '../../docendo'
import Loader from '../common/Loader'
import DModal from '../common/DModal'

export default {
  components: {DModal, Loader},
  props: {
    schoolId: {
      default: null
    },
    calendarId: {
      default: null
    },
    calendarType: {
      default: null
    },
    calendar: {
      default: null
    }
  },
  data () {
    return {
      isLoadingMerges: false,
      merges: [],
      theLoaderId: null
    }
  },
  computed: {
    isMergeCalendar () {
      const calType = this.calendar && this.calendar.type ? this.calendar.type : null
      return calType === 'merge'
    },
    schoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    mergesFilteredForCalendar () {
      return this.merges.filter(merge => merge.mergee_id === this.calendarId)
    },
    activeMergeCalendars () {
      return this.$store.getters.mergeCalendars
    },
    mergeCalendarsInclArchived () {
      return this.$store.getters.mergeCalendarsInclArchived
    },
    mergeCalsMerged () {
      return this.mergeCalendarsInclArchived.filter(mergeCalendar => this.mergesFilteredForCalendar.findIndex(mergesCal => mergesCal.merger_id === mergeCalendar.id) > -1)
    },
    possibleMergeCals () {
      return this.activeMergeCalendars.filter(mergeCalender => mergeCalender.school_year_id && mergeCalender.school_year_id === this.schoolYear.id && this.mergeCalsMerged.findIndex(cal => cal.id === mergeCalender.id) < 0)
    },
    allMergeCalendars () {
      const mergedCals = this.mergeCalsMerged.map(cal => ({
        ...cal,
        vIsMerged: true
      }))
      const cals = mergedCals.concat(this.possibleMergeCals)
      return this.$helpers.sortArrOnName(cals)
    },
    allCalendars () {
      return this.$store.state.calendars
    },
    mergesFilteredForMergeCalendar () {
      return this.merges.filter(merge => merge.merger_id === this.calendarId)
    },
    calendarsMerged () {
      const cals = this.allCalendars.filter(calendar => this.mergesFilteredForMergeCalendar.findIndex(mergesCal => mergesCal.mergee_id === calendar.id) > -1)
      return this.$helpers.sortArrOnName(cals)
    },
    possibleToMerge () {
      const typesToMerge = ['klass', 'club', 'other']
      const isCorrectTypes = this.allCalendars.filter(cal => typesToMerge.indexOf(cal.type) > -1)
      const isCorrectYear = isCorrectTypes.filter(cal => cal.school_year_id === this.schoolYear.id)
      const cals = isCorrectYear.filter(cal => this.calendarsMerged.findIndex(calMerged => calMerged.id === cal.id) < 0)
      return this.$helpers.sortArrOnName(cals)
    }
  },
  methods: {
    toggleMergeCalendar (calendar) {
      this.theLoaderId = calendar.id
      if (calendar.vIsMerged) {
        this.unMergeCalendar(calendar)
      } else {
        this.mergeCalendar(calendar)
      }
    },
    mergeCalendar (calendar) {
      docendo.mergeCalendar(this.schoolId, this.calendarId, calendar.id, success => {
        this.readCalendarsMerges()
      }, failure => {
        console.log({failure})
      })
    },
    unMergeCalendar (calendar) {
      docendo.unmergeCalendar(this.schoolId, this.calendarId, calendar.id, success => {
        this.readCalendarsMerges()
      }, failure => {
        console.log({failure})
      })
    },
    unMergeCalendarFromMergeCalendar (calendar) {
      this.theLoaderId = calendar.id
      docendo.unmergeCalendar(this.schoolId, calendar.id, this.calendarId, success => {
        this.readCalendarsMerges()
      }, failure => {
        console.log({failure})
      })
    },
    mergeCalendarFromMergeCalendar (calendar) {
      this.theLoaderId = calendar.id
      docendo.mergeCalendar(this.schoolId, calendar.id, this.calendarId, success => {
        this.readCalendarsMerges()
      }, failure => {
        console.log({failure})
      })
    },
    readCalendarsMerges (withSpinner) {
      if (withSpinner) {
        this.isLoadingMerges = true
      }
      docendo.listCalendarMerges(this.schoolId, success => {
        this.isLoadingMerges = false
        this.theLoaderId = null
        this.merges = success
      }, failure => {
        console.log('failure')
      })
    }
  },
  mounted () {
    this.readCalendarsMerges(true)
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.modal-merges {
  min-width: 400px;
}

.modal-merges__item {
  display: flex;
  justify-content: space-between;
  padding: 0.5rem;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
  margin: 0.25rem 0.5rem;
}

.modal-merges__item:hover {
  background-color: #eee;
}

.modal-merges__item label {
  color: var(--dark-blue);
}

.do-spinner--custom-marg {
  margin-right: 0.5rem;
}

.marg-05-rem {
  margin-left: 0.5rem;
}

.d-label__divider {
  border: 1px solid #d8d8d8;
  background: #efefef;
  padding: 0.25rem 1rem;
  border-width: 1px 0;
}

.d-label__divider.d-label__divider--top {
  border-width: 0 0 1px 0;
}
</style>



// WEBPACK FOOTER //
// CalendarMergeModal.vue?09294bf6